export default "__VITE_ASSET__DmYDNLL5__"